module.exports = {
    yourCourses: 'Seus cursos',
    instruction1: 'Selecione um curso para visualizá-lo ou editá-lo.',
    seeAll: 'Ver todos',
    noCourses: 'Você não possui cursos! Crie um agora mesmo utilizando o botão abaixo.',
    newCourse: 'Novo curso',
    instruction2: 'Crie um novo curso de forma rápida e fácil.',
    createNewCourse: 'Criar novo curso',
}